import { engine } from '@play-co/timestep-core';
import { ImageScaleView, View, ViewOpts } from '@play-co/timestep-core/ui';

export class RadialShine extends View {
  constructor(opts: ViewOpts) {
    super({
      width: 200,
      height: 200,
      ...opts,
    });

    const shine1 = new ImageScaleView({
      superview: this,
      image: 'assets/ui/shared/frames/shine.png',
      width: this.style.width,
      height: this.style.height,
      x: this.style.width / 2,
      y: this.style.height / 2,
      centerOnOrigin: true,
    });

    const shine2 = new ImageScaleView({
      superview: this,
      image: 'assets/ui/shared/frames/shine.png',
      width: this.style.width,
      height: this.style.height,
      x: this.style.width / 2,
      y: this.style.height / 2,
      centerOnOrigin: true,
    });

    const tick = (dt: number) => {
      shine1.style.r += dt * 0.001;
      shine2.style.r -= dt * 0.0013;
    };

    engine.subscribe('Tick', tick);

    this.addListener('ViewAdded', () => {
      engine.unsubscribe('Tick', tick); // Ensure we don't add multiple listeners
      engine.subscribe('Tick', tick);
    });

    this.addListener('ViewRemoved', () => {
      engine.unsubscribe('Tick', tick);
    });
  }
}
